// src/hooks/usePublish.js
import { useState, useCallback } from 'react';
import { publishVersion } from '../services/chatApi.js';

export default function usePublish(chatId) {
  const [loading, setLoading] = useState(false);
  return {
    loading,
    publish: useCallback(async (versionIdx) => {
      setLoading(true);
      try {
        const res = await publishVersion(chatId, versionIdx);
        return res;
      } finally {
        setLoading(false);
      }
    }, [chatId]),
  };
}
